import { PageLink, PageTitle } from '../../_metronic/layout/core'
import { ListWrapper } from './list/ListWrapper'

const contractTermBreadcrumbs: Array<PageLink> = [
  {
    title: 'Admin',
    path: '/admin/contract-terms',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ContractTermPage = () => {
  return (
    <>
      <PageTitle breadcrumbs={contractTermBreadcrumbs}>Termos de Consentimento</PageTitle>
      <ListWrapper />
    </>
  )
}

export default ContractTermPage
